import { VibrationCriteriaPoint } from "@soft-db/monitoring-api-client";

export function vcSort(point1: VibrationCriteriaPoint, point2: VibrationCriteriaPoint) {
	if (point1.x < point2.x) return -1;
	if (point1.x > point2.x) return 1;
	return point1.y < point2.y ? -1 : point1.y < point2.y ? 1 : 0;
}
